import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac8ae8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex flex-column h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-9" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-center mb-3" }, "Каталог")
  ])
], -1))
const _hoisted_3 = { class: "row flex-fill" }
const _hoisted_4 = { class: "col-12 col-lg-9" }
const _hoisted_5 = { class: "d-flex flex-column h-100" }
const _hoisted_6 = { class: "flex-fill" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center h-100"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Загрузка...")
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "col-12 col-lg-3 my-3 my-lg-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Products = _resolveComponent("Products")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CartCard = _resolveComponent("CartCard")!
  const _component_Filters = _resolveComponent("Filters")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createBlock(_component_Products, {
                  key: 1,
                  products: _ctx.products
                }, null, 8, ["products"]))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Pagination, {
              products: _ctx.products,
              onPageChange: _ctx.fetchProducts
            }, null, 8, ["products", "onPageChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Search, {
          onSearch: _ctx.handleSearch,
          query: _ctx.search_query
        }, null, 8, ["onSearch", "query"]),
        _hoisted_11,
        _createVNode(_component_CartCard),
        _hoisted_12,
        _createVNode(_component_Filters, { onChange: _ctx.handleFiltersChange }, null, 8, ["onChange"])
      ])
    ])
  ]))
}